import { Catalog, CatalogProps, Link, useIntl } from 'topwrite';
import { useCallback } from 'react';
import style from '../scss/summary.module.scss';
import { BsCaretDownFill } from '@react-icons/all-files/bs/BsCaretDownFill';
import { BsCaretRightFill } from '@react-icons/all-files/bs/BsCaretRightFill';
import classNames from 'classnames';
import useConfig from '@@/use-config';
import usePart from '@/lib/use-part';

const Item: CatalogProps['itemComponent'] = ({
    item,
    active,
    disabled,
    open,
    setOpen,
    children
}) => {
    const handleSpaceClick = useCallback(() => {
        if (children) {
            setOpen(!open);
        }
    }, [open, children]);

    return <li className={classNames({ [style.open]: open })}>
        <div className={classNames(style.item, {
            [style.active]: active,
            [style.disabled]: disabled,
        })}>
            <div className={style.whole} />
            <span className={style.space} onClick={handleSpaceClick}>
                {children && (open ? <BsCaretDownFill size={12} /> : <BsCaretRightFill size={12} />)}
            </span>
            <Link className={style.text} to={item}>
                {item.title}
            </Link>
        </div>
        {children}
    </li>;
};

const Part: CatalogProps['partComponent'] = ({ part, children }) => {

    const config = useConfig();
    const intl = useIntl();

    if (config.getValue('multiVersions')) {

        const currentPart = usePart();

        if (currentPart !== part) {
            return null;
        }

        return <>{children}</>;
    }

    return <div className={style.part}>
        <div className={style.title}>
            {part.title || intl.formatMessage({ defaultMessage: '未命名分组' })}
        </div>
        {children}
    </div>;
};

export default function Summary() {

    return <div className={style.summary}>
        <Catalog
            partComponent={Part}
            itemComponent={Item}
        />
    </div>;
}
